import { FC } from 'react';

export const BonusesInfoPanel: FC = () => {
  return (
    <div className="flex flex-col gap-3">
      <p className="font-comfortaa text-[24px] font-semibold my-1">Что такое бонусные рубли?</p>
      <p className="font-manrope text-[16px] text-gray-600">
        <b>Бонусные рубли</b> — это внутренняя валюта ZiNGiZi. Начисляются за регистрацию, промо-активности и
        приглашение друзей-психологов.
      </p>
      <p className="font-manrope text-[16px] text-gray-600">
        За каждого приглашённого психолога — <b>100 бонусных рублей.</b> Каждому зарегистрированному психологу также
        <b> 100 бонусных рублей</b>.
      </p>
      <p className="font-manrope text-[16px] text-gray-600">
        Курс простой: 1 бонусный рубль = 1 рубль.
        <br /> Следите за акциями в рассылках и Telegram!
      </p>

      <p className="font-comfortaa text-[24px] font-semibold my-1">Как применить?</p>
      <p className="font-manrope text-[16px] text-gray-600">
        <b>Бонусными рублями</b> можно оплатить часть стоимости подписки, обучающих курсов и других услуг на ZiNGiZi.
      </p>
      <p className="font-manrope text-[16px] text-gray-600">
        При оформлении заказ указана возможность оплаты бонусами, просто выберите сколько бонусов хотите списать.
      </p>
    </div>
  );
};
